export default __webpack_public_path__ + "static/Difi.io_v4-02-bdf1a9478e7eafeedd926066b5321cb9.jpg";